:host {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  min-height: 56px;
  padding: 0.5rem 0;
  margin-top: -1px;
  color: var(--sy-primary-contrast, #fff);
  background: var(--sy-primary, #000);
}

.menu {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 16px;

  @media screen and (max-width: 425px) {
    flex-grow: 1;
  }
}

.menu-item-text {
  color: var(--sy-primary-contrast, #fff);
}

.sy-list-item {
  padding-left: 60px;
}

.menu-content {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  max-width: 100%;
  padding: 0;

  a,
  .menu-item-button {
    background: none;
    border: none;
    color: var(--sy-primary-contrast, #fff);
    text-decoration: none;
    padding: 0.5rem 0.6rem;
    display: flex;
    align-items: center;
  }

  .menu-item-button:hover,
  .menu-item-button:focus,
  a:hover,
  a:focus {
    color: #ffffffbf; // Hover e focus
  }

  .menu-item-button.active,
  a.active {
    color: var(--sy-accent-active, #288cec);
  }
}

.categories {
  display: flex;
  flex-flow: row nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
}

.divider {
  padding: 0.5rem 0.6rem;

  .vertical-bar {
    background-color: #fffc;
    width: 1px;
    height: 20px;
  }
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dropdown-menu {
  border-radius: 0;
  display: flex;
  flex-direction: column;
  background-color: var(--sy-primary, #000);
  padding: 0.5rem 0;
  z-index: 10;

  a {
    color: var(--sy-primary-contrast, #fff);
    padding: 0.5rem 1rem;
    text-decoration: none;
  }

  a:hover,
  a:focus {
    color: rgb(255 255 255 / 75%);
  }

  a.active {
    color: var(--sy-accent-active, #288cec);
  }
}

sy-dropdown {
  --sy-dropdown-border: none;
  --sy-border-radius: none;
}

.tree {
  &.closed {
    display: flex;
    width: 100%;
    justify-content: flex-start;
  }

  margin-top: 10px;

  .tree-item {
    padding: 0.5rem;
    border-left: 2px solid transparent;
    transition: border-left-color 0.3s ease;

    &:hover {
      border-left-color: var(--sy-accent-active, #288cec);
    }

    &.active {
      font-weight: bold;
    }
  }
}

.tree-container {
  display: none;
  width: 100%;

  @media (max-width: 575px) {
    display: flex;
    flex-direction: column;
  }
}

.menu-item-container {
  a {
    color: var(--sy-primary-contrast, #fff);
    text-decoration: none;
    padding: 8px;
    display: block;
  }

  .child {
    padding-left: 50px;
    display: block;
    text-decoration: none;
    color: var(--sy-primary-contrast, #fff);

    &:hover {
      background-color: #525252;
    }
  }
}

sy-text {
  // color: #fff;
  // padding-left: 10px;

  &:hover {
    color: #c8c8c9;
  }
}

sy-icon {
  // transform: rotate(90deg);
  color: #ffffffbf;
  font-size: 30px;
}

@media (max-width: 575px) {
  .menu {
    display: none;
  }

  .categories {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}

.subitems-container {
  padding-left: 40px;
}
